module.exports = __webpack_public_path__ + "static/media/aldi9.bda6bf2b.jpg";